import { createAction } from "redux-actions";
import { ViewPostConstants } from "../constants/viewPost.constants";

export const fetchPost = createAction(ViewPostConstants.FETCH_POST);

export const fetchPostSuccess = createAction(
    ViewPostConstants.FETCH_POST_SUCCESS
);

export const fetchPostFailure = createAction(
    ViewPostConstants.FETCH_POST_FAILURE
);



// WEBPACK FOOTER //
// ./src/actions/viewPost.actions.js